import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/device/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/device/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/device/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/device/save', params, options);

export const update = (params, options) => request.post('/api/park/device/update', params, options);
